export default function appStore(state, partialState) {
  const [[key, value]] = Object.entries(partialState);
  return {
    ...state,
    ...{ [key]: value },
  };
}
